import { createSlice } from '@reduxjs/toolkit';

export const paymentFrequencySlice = createSlice({
  name: 'payment_frequency',
  initialState: {
    payment_frequency_list: [],
    payment_frequency_select: [],
  },
  reducers: {
    setPaymentFrecuencyRedux: (state, { payload }) => {
      state.payment_frequency_list = payload;
    },
    setPaymentFrecuencySelectRedux: (state, { payload }) => {
      state.payment_frequency_select = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setPaymentFrecuencyRedux, setPaymentFrecuencySelectRedux } =
  paymentFrequencySlice.actions;
